import { inject, provideAppInitializer } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { firstValueFrom } from 'rxjs';
import { environment } from '@env';
import { AUTH_SERVICE_TOKEN, IAuthService } from '../models/iauth-service.model';
import { AuthenticationType } from '../models/authentication-type.enum';

const usesMsal = (): boolean => {
  return (
    environment.authenticationType === AuthenticationType.AzureActiveDirectory ||
    environment.authenticationType === AuthenticationType.AzureB2C
  );
};

export const authInitializerProvider = provideAppInitializer(() => {
  const authService = inject<IAuthService>(AUTH_SERVICE_TOKEN);
  const msalService = usesMsal() ? inject(MsalService) : null;

  return (async () => {
    if (msalService) {
      await firstValueFrom(msalService.initialize());
    }

    authService.init();
  })();
});
